import React from 'react'
import { Container, Text, Spacer } from 'roadie-ui'
import { Time } from 'roadie-ui'
import { Link } from 'react-router-dom'
import { LocalizedRichText } from 'localization'

export type Consolidation = {
  id: number
  title: string
  state: string
  stops: any[]
  route: string
  estimated_distance: number
  delivery_completed_at: number
  senders: Sender[]
  total_payout: number
}

type Sender = {
  id: number
  name: string
  avatar_url: string
  verified_avatar_url: string | null
}

type SenderSectionProps = {
  senders: Sender[]
}

const SenderSection: React.FC<SenderSectionProps> = ({ senders }) => {
  if (!senders || senders.length === 0) {
    return null
  }

  return (
    <Container.Grid $display="flex" $alignItems="center" $gridGap="0.8rem" style={{ marginBottom: '0.4rem' }}>
      {senders.map((sender) => (
        <Container.Grid key={sender.id} $display="flex" $alignItems="center" $gridGap="0.8rem">
          <Container.Grid
            style={{
              width: '1.6rem',
              height: '1.6rem',
              borderRadius: '50%',
              overflow: 'hidden',
            }}
          >
            <img
              src={sender.avatar_url}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              alt={`${sender.name} avatar`}
            />
          </Container.Grid>
          <Text.Overline $color="neutral-darker">{sender.name}</Text.Overline>
        </Container.Grid>
      ))}
    </Container.Grid>
  )
}

export interface TransactionCellProps {
  consolidation: Consolidation
}

export const TransactionCell: React.FC<TransactionCellProps> = ({ consolidation }) => {
  const completedDate = new Time(consolidation.delivery_completed_at * 1000)

  return (
    <Link to={`/delivery/${consolidation.id}`}>
      <Container.Grid $display="flex" $alignItems="center" $padding="2.4rem" style={{ position: 'relative' }}>
        {/* Date section */}
        <Container.Grid
          style={{
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '3.2rem',
            marginRight: '3.2rem',
          }}
        >
          <Text.Caption $color="neutral-darker">{completedDate.format({ month: 'short' })}</Text.Caption>
          <Text.H6 $color="neutral-black">{completedDate.format({ day: '2-digit' })}</Text.H6>
          <Text.Caption $color="neutral-darker">{completedDate.format({ weekday: 'short' })}</Text.Caption>
        </Container.Grid>

        {/* Details section */}
        <Container.Grid style={{ flex: '1 1 100%', wordBreak: 'break-word' }}>
          <SenderSection senders={consolidation.senders} />
          <Text.H6 $color="neutral-black">{consolidation.title}</Text.H6>
          <Spacer $height="0.4rem" />
          <Text.Caption $color="neutral-darker">
            <LocalizedRichText
              translationKey="dweb_block_payments_transaction_cell_completed_at_value1"
              params={{ value1: completedDate.format({ hour: 'numeric', minute: '2-digit' }) }}
            />
          </Text.Caption>
        </Container.Grid>

        {/* Amount section */}
        <Container.Grid style={{ marginLeft: '3.2rem' }}>
          <Text.H4 $color="neutral-black" style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Text.Body1
              style={{
                fontSize: '1.8rem',
                lineHeight: 1,
                position: 'relative',
                top: '0.5rem',
              }}
            >
              $
            </Text.Body1>
            <span>{consolidation.total_payout.toFixed(2).split('.')[0]}</span>
            <Text.Body1
              style={{
                fontSize: '1.8rem',
                lineHeight: 1,
                position: 'relative',
                top: '0.5rem',
              }}
            >
              {consolidation.total_payout.toFixed(2).split('.')[1]}
            </Text.Body1>
          </Text.H4>
        </Container.Grid>
      </Container.Grid>
    </Link>
  )
}

export default TransactionCell
